(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('vessel', {
                parent: 'entity',
                url: '/vessel',
                data: {
                    authorities: [],
                    pageTitle: 'Vessels'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/vessel/list/vessel.html',
                        controller: 'VesselController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_VESSEL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_VESSEL, access);
                }]
            });
    }
})();
